module.exports = __webpack_public_path__ + "static/media/hdfc_icn_landing_card_1.b3fe812f.png";